module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/read-more/read-more.component.css
// module id = ./src/app/Screens/read-more/read-more.component.css
// module chunks = main